import { ff } from '@atlassian/jira-feature-flagging';
import type { HealthCheckFunction } from '../../types';

const globalObj = window || global;
const defaultHealthcheck = (callback: (obj?: { isSuccess: boolean }) => void) =>
	callback({ isSuccess: true });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const failingHealthcheck = (callback: any) => callback({ isSuccess: false });

export const provideHealthcheck = (healthcheck: HealthCheckFunction = defaultHealthcheck) => {
	const isHealthcheckAllFailEnabled = ff('fe.platform.healthcheck.allfail.enabled');

	if (isHealthcheckAllFailEnabled) {
		globalObj.performHealthcheck = failingHealthcheck;

		return;
	}

	globalObj.performHealthcheck = healthcheck;
};
